import { Matrix3, Cartesian3 } from "cesium";
import proj4 from "proj4";

export function getDirectionMatrix(
  localConverter: proj4.Converter,
  point: Cartesian3,
) {
  // transform point to project CRS
  const point_t = localConverter.forward([point.x, point.y, point.z]);

  // Get directional vectors
  const point_tx = [point_t[0] + 1, point_t[1], point_t[2]];
  const point_tx_inv = localConverter.inverse(point_tx);
  let x_unit = new Cartesian3();
  Cartesian3.subtract(
    new Cartesian3(point_tx_inv[0], point_tx_inv[1], point_tx_inv[2]),
    point,
    x_unit,
  );

  const point_ty = [point_t[0], point_t[1] + 1, point_t[2]];
  const point_ty_inv = localConverter.inverse(point_ty);
  let y_unit = new Cartesian3();
  Cartesian3.subtract(
    new Cartesian3(point_ty_inv[0], point_ty_inv[1], point_ty_inv[2]),
    point,
    y_unit,
  );

  const point_tz = [point_t[0], point_t[1], point_t[2] + 1];
  const point_tz_inv = localConverter.inverse(point_tz);
  let z_unit = new Cartesian3();
  Cartesian3.subtract(
    new Cartesian3(point_tz_inv[0], point_tz_inv[1], point_tz_inv[2]),
    point,
    z_unit,
  );

  // Create matrix
  const m_unit = new Matrix3(
    x_unit.x,
    y_unit.x,
    z_unit.x,
    x_unit.y,
    y_unit.y,
    z_unit.y,
    x_unit.z,
    y_unit.z,
    z_unit.z,
  );

  return m_unit;
}
